export enum PaymentMethod {
  Stripe = "stripe",
  Coinbase = "coinbase",
}

export default PaymentMethod;
